import { Close } from '@mui/icons-material'
import { Autocomplete, Button, Grid2, IconButton, MenuItem, Skeleton, TextField, Typography } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import api from '../../../../utils/axios'
import { IEmployee, IOrder } from 'sierra'
import { useApp } from '../../../../contexts/AppContext'

export default function OrderAssignment() {
    const location = useLocation()
    const navigate = useNavigate()
    const {translate} = useApp()

    const order: IOrder = location.state?.order;

    const [employees, setEmployees] = useState<IEmployee[]>()
    const [assignedTo, setAssignedTo] = useState<number | undefined | null>(order.assigned_to)
    const [assigning, setAssigning] = useState(false)


    useEffect(() => {
        fetchEmployees()
    }, [])

    const fetchEmployees = () => {
        api.get(`/employees`).then(({ data }) => setEmployees(data)).catch(console.error)
    }

    const updateAssignment = () => {
        if (!assignedTo) return;
        setAssigning(true)
        api.patch(`/orders/${order.order_id}/assignedTo`, { assigned_to: assignedTo }, { meta: { showSnackbar: true } }).catch(console.error).finally(() => setAssigning(false))
    }

    if (!order) navigate(-1)

    return (
        <Grid2 container padding={2} flexDirection={'column'} height={'100%'}>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'}>
                <Grid2>
                    <Typography variant='h5' fontWeight={'bold'}>
                        {translate("Update Order Assignment")}
                    </Typography>
                </Grid2>
                <Grid2>
                    <IconButton onClick={() => navigate('/system/orders/manage?order_id=' + order.order_id)}>
                        <Close />
                    </IconButton>
                </Grid2>
            </Grid2>
            <Grid2 container size='grow' justifyContent={'center'} alignItems={'center'} >
                <Grid2 container size='grow' flexDirection={'column'} gap={3} maxWidth={400}>
                    <Grid2>
                        {
                            !employees ? <Skeleton height={75} /> :
                                <Autocomplete
                                    getOptionLabel={(option) => option.name}
                                    options={employees}
                                    onChange={(_, v) => v && setAssignedTo(v.user_id)}
                                    getOptionDisabled={(option) => option.branch_id !== order.branch?.branch_id ? true : false}
                                    value={employees.find(emp => emp.user_id === assignedTo)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            size='small'
                                            label={translate("Select Employee")}
                                        />
                                    )}
                                />
                            // <TextField required select fullWidth size='small' value={assignedTo || 'select'} onChange={(e) => setAssignedTo(e.target.value)}>
                            //     <MenuItem value={'select'}>
                            //         Select Employee
                            //     </MenuItem>
                            //     {employees.map(emp => (
                            //         <MenuItem key={emp.user_id} disabled={emp.branch_id !== order.branch?.branch_id} value={emp.user_id}>
                            //             {emp.name}
                            //         </MenuItem>
                            //     ))}
                            // </TextField>
                        }
                    </Grid2>
                    <Grid2>
                        <Button disabled={assigning || !assignedTo || assignedTo === order.assigned_to} variant='contained' fullWidth size='small' onClick={updateAssignment}>
                            {translate("UPDATE EMPLOYEE ASSIGNMENT")}
                        </Button>
                    </Grid2>
                </Grid2>
            </Grid2>
        </Grid2>
    )
}